import { render, staticRenderFns } from "./Crisis_intervention.vue?vue&type=template&id=e1801fc4"
import script from "./Crisis_intervention.vue?vue&type=script&lang=js"
export * from "./Crisis_intervention.vue?vue&type=script&lang=js"
import style0 from "./Crisis_intervention.vue?vue&type=style&index=0&id=e1801fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports